module.exports = __webpack_public_path__ + "img/bg-v.8d962f2b.png";